// @flow

import styled from 'styled-components';
import { SEMIBOLD } from '../../../helpers/fontWeight';
import type { Theme } from '../../../types';

export default styled<any, Theme>('div')`
  color: ${props => props.theme.pdbInfo.title.color};
  font-family: ${props => props.theme.pdbInfo.title.fontFamily || 'inherit'};
  font-size: 1rem;
  font-weight: ${SEMIBOLD};
`;
